<template>
  <section class="faq-layout">
    <h1 v-html="$t('pages.faq.heading')" />
    <div class="index">
      <div
        v-for="(anchor, index) in faqData"
        :key="anchor.title"
        class="index-item"
      >
        <span v-html="`${index + 1}. `" />
        <a
          :href="`#faq-${anchor.title}`"
          v-html="anchor.title"
        />
      </div>
    </div>
    <faq-section
      v-for="(section, index) in faqData"
      :key="section.title"
      :index="index"
      :section="section"
      :has-visible-question="openSectionIndex === index"
      @toggle="onToggle(index)"
    />
  </section>
</template>
<script>

export default {
  components: {
    FaqSection: () => import(/* webpackChunkName: "faq"  */ `./FaqSection`),
  },
  data() {
    return {
      openSectionIndex: null,
    }
  },
  computed: {
    faqData() { return window.renaultRent.faqs },
  },
  methods: {
    onToggle(openSectionIndex) {
      if (this.openSectionIndex === openSectionIndex) {
        // this.openSectionIndex = null
        return
      }
      this.openSectionIndex = openSectionIndex
    },
  },
}

</script>
<style lang="scss" scoped>

.faq-layout {
  margin: 20px auto;
  width: calc(100vw - 20px);

  @include teq-breakpoint($large) {
    max-width: calc(100% - 186px);
  }

  h1 {
    font-family: $f-graphie-extrabold;
    font-size: 56px;
    font-style: normal;
    line-height: 100%;
    padding: 2.5rem 0;
    text-align: center;

    @include teq-breakpoint($large) {
      font-size: 72px;
      line-height: 72px;
    }
  }
}

.index {
  color: $c-boulder;
  font-size: 1.6rem;
  margin: 0 0 40px;
}

a {
  color: black;
  text-decoration: underline;
}
</style>
